// extracted by mini-css-extract-plugin
export default {"opponent":"OpponentCard_opponent__AQxew","oppInfoWrapper":"OpponentCard_oppInfoWrapper__IShDb"};